import {createContext, type ReactNode, use, useCallback, useMemo, useState} from 'react'

type NavigationContextType = {
  isNavigationOpen: boolean
  openNavigation: () => void
  closeNavigation: () => void
}

const NavigationContext = createContext<NavigationContextType | null>(null)

type NavigationContextProviderType = {
  children: ReactNode
}

export function NavigationContextProvider({children}: NavigationContextProviderType) {
  const [isNavigationOpen, setIsNavigationOpen] = useState<boolean>(false)

  const closeNavigation = useCallback(() => {
    setIsNavigationOpen(false)
  }, [])

  const openNavigation = useCallback(() => {
    setIsNavigationOpen(true)
  }, [])

  const contextValue: NavigationContextType = useMemo(() => {
    return {
      isNavigationOpen,
      openNavigation,
      closeNavigation,
    }
  }, [isNavigationOpen, openNavigation, closeNavigation])

  return <NavigationContext value={contextValue}>{children}</NavigationContext>
}

export const useNavigationContext = () => {
  const context = use(NavigationContext)
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationContextProvider.')
  }

  return context
}
